import { Result } from "antd"

const NotFound = ()=>{
    return <Result status='404' title="صفحه یافت نشد!" subTitle="صفحه که دنبال آن موجود نیست." />
}

export default NotFound;